module.exports = [
        {
            "short": "AL",
            "long": "alabama",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "60"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "50"
                }
            ]
        },
        {
            "short": "AK",
            "long": "alaska",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "20"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "28"
                }
            ]
        },
        {
            "short": "AS",
            "long": "american samoa",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "11"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "9"
                }
            ]
        },
        {
            "short": "AZ",
            "long": "arizona",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "85"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "58"
                }
            ]
        },
        {
            "short": "AR",
            "long": "arkansas",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "37"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "40"
                }
            ]
        },
        {
            "short": "CA",
            "long": "california",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "551"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "172"
                }
            ]
        },
        {
            "short": "CO",
            "long": "colorado",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "78"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "37"
                }
            ]
        },
        {
            "short": "CT",
            "long": "connecticut",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "71"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "28"
                }
            ]
        },
        {
            "short": "DE",
            "long": "delaware",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "32"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "16"
                }
            ]
        },
        {
            "short": "DC",
            "long": "district of columbia",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "44"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "19"
                }
            ]
        },
        {
            "short": "FL",
            "long": "florida",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "246"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "99"
                }
            ]
        },
        {
            "short": "GA",
            "long": "georgia",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "117"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "76"
                }
            ]
        },
        {
            "short": "GU",
            "long": "guam",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "12"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "9"
                }
            ]
        },
        {
            "short": "HI",
            "long": "hawaii",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "34"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "19"
                }
            ]
        },
        {
            "short": "ID",
            "long": "idaho",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "27"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "32"
                }
            ]
        },
        {
            "short": "IL",
            "long": "illinois",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "183"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "69"
                }
            ]
        },
        {
            "short": "IN",
            "long": "indiana",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "92"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "57"
                }
            ]
        },
        {
            "short": "IA",
            "long": "iowa",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "51"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "30"
                }
            ]
        },
        {
            "short": "KS",
            "long": "kansas",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "37"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "40"
                }
            ]
        },
        {
            "short": "KY",
            "long": "kentucky",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "60"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "46"
                }
            ]
        },
        {
            "short": "LA",
            "long": "louisiana",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "59"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "46"
                }
            ]
        },
        {
            "short": "ME",
            "long": "maine",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "30",
                },
                {
                    "party": "Rep",
                    "totalDelegates": "23"
                }
            ]
        },
        {
            "short": "MD",
            "long": "maryland",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "120"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "38"
                }
            ]
        },
        {
            "short": "MA",
            "long": "massachusetts",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "115"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "42"
                }
            ]
        },
        {
            "short": "MI",
            "long": "michigan",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "147"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "59"
                }
            ]
        },
        {
            "short": "MN",
            "long": "minnesota",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "93"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "38"
                }
            ]
        },
        {
            "short": "MS",
            "long": "mississippi",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "41"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "40"
                }
            ]
        },
        {
            "short": "MO",
            "long": "missouri",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "84"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "52"
                }
            ]
        },
        {
            "short": "MP",
            "long": "northern mariana islands",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "11"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "9"
                }
            ]
        },
        {
            "short": "MT",
            "long": "montana",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "27"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "27"
                }
            ]
        },
        {
            "short": "NE",
            "long": "nebraska",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "30"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "36"
                }
            ]
        },
        {
            "short": "NV",
            "long": "nevada",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "43"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "30"
                }
            ]
        },
        {
            "short": "NH",
            "long": "new hampshire",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "32"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "23"
                }
            ]
        },
        {
            "short": "NJ",
            "long": "new jersey",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "142"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "51"
                }
            ]
        },
        {
            "short": "NM",
            "long": "new mexico",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "43"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "24"
                }
            ]
        },
        {
            "short": "NY",
            "long": "new york",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "291"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "95"
                }
            ]
        },
        {
            "short": "NC",
            "long": "north carolina",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "120"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "72"
                }
            ]
        },
        {
            "short": "ND",
            "long": "north dakota",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "23"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "28"
                }
            ]
        },
        {
            "short": "OH",
            "long": "ohio",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "160"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "66"
                }
            ]
        },
        {
            "short": "OK",
            "long": "oklahoma",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "42"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "43"
                }
            ]
        },
        {
            "short": "OR",
            "long": "oregon",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "74"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "28"
                }
            ]
        },
        {
            "short": "PA",
            "long": "pennsylvania",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "208"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "71"
                }
            ]
        },
        {
            "short": "PR",
            "long": "puerto rico",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "67"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "23"
                }
            ]
        },
        {
            "short": "RI",
            "long": "rhode island",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "33"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "19"
                }
            ]
        },
        {
            "short": "SC",
            "long": "south carolina",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "59"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "50"
                }
            ]
        },
        {
            "short": "SD",
            "long": "south dakota",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "25"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "29"
                }
            ]
        },
        {
            "short": "TN",
            "long": "tennessee",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "75"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "58"
                }
            ]
        },
        {
            "short": "TX",
            "long": "texas",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "251"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "155"
                }
            ]
        },
        {
            "short": "UT",
            "long": "utah",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "37"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "40"
                }
            ]
        },
        {
            "short": "VT",
            "long": "vermont",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "26"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "16"
                }
            ]
        },

        {
            "short": "VA",
            "long": "virginia",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "108"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "49"
                }
            ]
        },
        {
            "short": "VI",
            "long": "u.s. virgin islands",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "12",
                },
                {
                    "party": "Rep",
                    "totalDelegates": "9",
                }
            ]
        },
        {
            "short": "WA",
            "long": "washington",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "118"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "44"
                }
            ]
        },
        {
            "short": "WV",
            "long": "west virginia",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "37"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "34"
                }
            ]
        },
        {
            "short": "WI",
            "long": "wisconsin",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "96"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "42"
                }
            ]
        },
        {
            "short": "WY",
            "long": "wyoming",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "18"
                },
                {
                    "party": "Rep",
                    "totalDelegates": "29"
                }
            ]
        },
        {
            "short": "DA",
            "long": "democrats abroad",
            "races": [
                {
                    "party": "Dem",
                    "totalDelegates": "17"
                }
            ]
        }
    ]


/** WEBPACK FOOTER **
 ** ./src/js/data/states-config.js
 **/